import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hr-mobile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hr-mobile.html',
  styleUrls: ['./hr-mobile.css'],
})
export class HrMobileComponent {}
